import { apiClient } from "./httpClient";
import { unwrapEnvelope, unwrapList, unwrapMeta } from "./response";

export const clinicalApi = {
  async listVisits(params = {}) {
    const response = await apiClient.get("/clinical/visits", { params });
    return { data: unwrapList(response.data), meta: unwrapMeta(response.data) };
  },

  async getDoctorQueue(doctorId) {
    const response = await apiClient.get(`/clinical/doctors/${doctorId}/queue`);
    return unwrapEnvelope(response.data, {
      primary_visit: null,
      active_visits: [],
      waiting_queue: [],
      skipped_queue: [],
      current_visit: null,
      queue: [],
      next_token: 1
    });
  },

  async getVisit(id) {
    const response = await apiClient.get(`/clinical/visits/${id}`);
    return unwrapEnvelope(response.data, null);
  },

  async createVisit(payload) {
    const response = await apiClient.post("/clinical/visits", payload);
    return unwrapEnvelope(response.data, null);
  },

  async startVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/start`);
    return unwrapEnvelope(response.data, null);
  },

  async pauseVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/pause`);
    return unwrapEnvelope(response.data, null);
  },

  async resumeVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/resume`);
    return unwrapEnvelope(response.data, null);
  },

  async skipVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/skip`);
    return unwrapEnvelope(response.data, null);
  },

  async recallVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/recall`);
    return unwrapEnvelope(response.data, null);
  },

  async setVisitPriority(visitId, priority) {
    const response = await apiClient.patch(`/clinical/visits/${visitId}/priority`, { priority });
    return unwrapEnvelope(response.data, null);
  },

  async startNextWaitingVisit(doctorId) {
    const response = await apiClient.post(`/clinical/doctors/${doctorId}/queue/next`);
    return unwrapEnvelope(response.data, null);
  },

  async updateVisit(id, payload) {
    const response = await apiClient.patch(`/clinical/visits/${id}`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async addNote(visitId, payload) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/notes`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async upsertSoapNote(visitId, payload) {
    const response = await apiClient.put(`/clinical/visits/${visitId}/soap-note`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async addDiagnosis(visitId, payload) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/diagnoses`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async addPrescription(visitId, payload) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/prescriptions`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async createLabRequest(visitId, payload) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/lab-requests`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async saveConsultationTab(visitId, payload) {
    const response = await apiClient.put(`/clinical/visits/${visitId}/workspace/consultation`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async savePrescriptionsTab(visitId, payload) {
    const response = await apiClient.put(`/clinical/visits/${visitId}/workspace/prescriptions`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async finalizePrescriptionsTab(visitId, payload = {}) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/workspace/prescriptions/finalize`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async amendPrescriptionsTab(visitId, payload = {}) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/workspace/prescriptions/amend`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async saveOrdersTab(visitId, payload) {
    const response = await apiClient.put(`/clinical/visits/${visitId}/workspace/orders`, payload);
    return unwrapEnvelope(response.data, null);
  },

  async completeVisit(visitId) {
    const response = await apiClient.post(`/clinical/visits/${visitId}/complete`);
    return unwrapEnvelope(response.data, null);
  }
};
